import { Component, Input } from '@angular/core';

@Component({
  selector: 'dal-shared-ui-audio-upload-thumbnail',
  templateUrl: './audio-upload-thumbnail.component.html',
  styleUrl: './audio-upload-thumbnail.component.scss',
})
export class AudioUploadThumbnailComponent {
  @Input() file: File;
}
